// ========================================
// 📄 src/utils/formatters.js
// ========================================
export const formatDate = (date) => {
  if (!date) return "N/A";

  if (date.toDate) {
    date = date.toDate();
  }

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(date));
};

export const formatDateTime = (date) => {
  if (!date) return "N/A";

  if (date.toDate) {
    date = date.toDate();
  }

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
};

export const formatPhone = (phone) => {
  if (!phone) return "N/A";
  const cleaned = phone.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/);
  if (match) {
    return `${match[1]} ${match[2]} ${match[3]} ${match[4]} ${match[5]}`;
  }
  return phone;
};

export const truncateText = (text, maxLength = 100) => {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

const CURRENCY_NORMALIZATION_MAP = {
  FCFA: "XOF",
  CFA: "XOF",
  XAOF: "XOF",
  XOF: "XOF",
  XAF: "XAF",
};

export const normalizeCurrencyCode = (currency, fallback = "EUR") => {
  if (!currency || typeof currency !== "string") {
    return fallback;
  }

  const compact = currency.replace(/\s+/g, "").toUpperCase();
  if (CURRENCY_NORMALIZATION_MAP[compact]) {
    return CURRENCY_NORMALIZATION_MAP[compact];
  }

  if (/^[A-Z]{3}$/.test(compact)) {
    return compact;
  }

  return fallback;
};
